module.exports = __webpack_public_path__ + "img/2.d109cea8.jpg";